import styled from 'styled-components';

const ContainerDataHora = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  margin-bottom: 10px;
  img {
      margin-left:15px;
      width: 20px;
      cursor: pointer;
  }
`;
export default ContainerDataHora;
